import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Attachments & Additional Information\n          ")
], -1);
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Comments / additional information:", -1);
const _hoisted_7 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_8 = ["value", "disabled"];
const _hoisted_9 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_10 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FileUploader = _resolveComponent("FileUploader");
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createVNode(_component_FileUploader, {
                    name: "additional-attachments",
                    files: _ctx.formData.files,
                    disabled: _ctx.disableForm,
                    "document-short-id": _ctx.document?.shortId,
                    uploading: _ctx.uploading,
                    onUpdateFiles: _ctx.handleUpdateFiles,
                    onFileUploading: _cache[0] || (_cache[0] = ($event) => (_ctx.uploading = $event))
                }, null, 8, ["files", "disabled", "document-short-id", "uploading", "onUpdateFiles"]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("textarea", {
                            id: "comments",
                            name: "comments",
                            value: _ctx.formData.comments,
                            rows: "3",
                            class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                        }, null, 42, _hoisted_8)
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("button", {
                        disabled: _ctx.uploading,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_10)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
